/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { companiesAPI } from '../../store/actions/companiesActions';
import './CommunityPage.scss';

export default function CommunityPage() {
  const { t, i18n } = useTranslation(['community_page', 'notifications']);
  const dispatch = useDispatch();
  const { currentPage } = useSelector((state) => state.companies);
  const [ukDataKeys, setUkDataKeys] = useState([]);

  useEffect(() => {
    window.scrollTo({
      left: 0,
      top: 0,
      behavior: 'instant',
    });

    dispatch(companiesAPI());
  }, [currentPage]);

  useEffect(() => {
    const header = document.querySelector('.Header.fixed');
    const communityPage = document.querySelector('.CommunityPage');
    const footer = document.querySelector('.Footer');
    const minimumRequiredHeight = document.documentElement.clientHeight - (header.offsetHeight + footer.offsetHeight);

    communityPage.style.minHeight = `${minimumRequiredHeight}px`;
  }, []);

  useEffect(() => {
    fetch(`/enterprises/${i18n.language}.json`)
      .then((response) => response.json())
      .then((data) => {
        const keys = Object.keys(data);
        setUkDataKeys(keys);
      });
  }, []);

  return (
    <section className="CommunityPage">
      <div className="wrapper">
        <div className="community-page-content">
          <div className="community-page-content-top-row">
            <a
              className="previous-page-link"
              href={
                i18n.languages[0] === 'en'
                  ? '/en/'
                  : '/'
              }
            >
              {t('previous_page_title')}
            </a>
            <h1 className="heading-one">
              {t('heading')}
            </h1>
          </div>

          <div className="community-page-main-content">

            <div className="industries-list">
              {ukDataKeys.map((value) => (
                <div key={value} className="industry-item">
                  <a href={`/community/${value}/`} className="industry-link">
                    {t(`industries.${value}`)}
                  </a>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
